<!--
통관금액 환율변동주의 라벨 컴포넌트 (TASK-150, 2026-09-20 / TASK-151, 2026-09-21)
------------------------------------
세관신고금액(USD 환산액) 이 [min, max] 구간(양끝 포함)이면 "환율변동주의" 주황 배지(경고 아이콘) + hover 툴팁(한 줄)을 노출한다.
- 순수 표시 컴포넌트 — 구간(min/max) 은 호출측(blade partial)이 RegionCache::getCustomsUsdRateWarningRange() 로 계산해 전달한다.
  min/max 가 null 이면(= 현지화폐가 USD 인 센터거나 대상 아님) 비노출.
- 구간·USD 제외 정책 SSOT = App\Region\RegionAbstract::getCustomsUsdRateWarningRange() (TASK-151)
-->
<template>
    <div class="customs-usd-rate-warning" v-if="visible">
        <!-- D안 (사용자 결정 2026-09-20): 소프트 틴트 칩 — 연한 주황 배경 + 진한 주황 글씨 + 같은 계열 얇은 테두리 + 알약형 + 경고 아이콘.
             기존 "일반통관" 빨간 채움 배지(150 초과)와 색·질감 두 축으로 위계 구분. UIkit 라벨 미사용 (자체 스타일) -->
        <span class="customs-usd-rate-warning-chip"
              uk-tooltip="title: 달러 환산 금액은 관세청고시 &quot;주간(수입)환율&quot;에 따라 변동됩니다.; pos: top-left; cls: uk-active customs-usd-rate-warning-tooltip">
            <i class="material-icons">warning</i>
            환율변동주의
        </span>
    </div>
</template>

<script>
    export default {
        props: {
            // (number|null) 세관신고금액 USD 환산액 (customs_usd / h_customs_usd)
            customsUsd: {
                type: Number,
                default: null,
            },

            // (number|null) 구간 하한 (포함). null 이면 비노출
            min: {
                type: Number,
                default: null,
            },

            // (number|null) 구간 상한 (포함). null 이면 비노출
            max: {
                type: Number,
                default: null,
            },
        },
        computed: {
            /**
             * 노출여부
             *  - min/max 가 둘 다 지정되고, customsUsd 가 [min, max] 구간 (양끝 포함)
             * @return {boolean}
             */
            visible() {
                if (this.min === null || this.max === null) {
                    return false;
                }
                if (this.customsUsd === null || this.customsUsd === undefined) {
                    return false;
                }
                return this.customsUsd >= this.min && this.customsUsd <= this.max;
            },
        },
    }
</script>

<style lang="scss" scoped>
    .customs-usd-rate-warning {
        margin-top: 3px;
    }
    /* D안 소프트 틴트 칩 — amber 50 배경 / 800 글씨 / 100 테두리 / 600 아이콘 */
    .customs-usd-rate-warning-chip {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        background: #FAEEDA;
        color: #854F0B;
        border: 1px solid #FAC775;
        border-radius: 999px;
        padding: 2px 9px 2px 7px;
        font-size: 12px;
        font-weight: bold;
        line-height: 1.4;
        white-space: nowrap;
        cursor: default;
    }
    .customs-usd-rate-warning-chip .material-icons {
        font-size: 14px;
        line-height: 1;
        color: #BA7517;
    }
</style>

<!-- 툴팁은 body 직속으로 붙으므로 비-scoped 스타일 (uk-tooltip 기본 max-width 200px → 한 줄 표시, 사용자 요청 2026-09-20) -->
<style lang="scss">
    .uk-tooltip.customs-usd-rate-warning-tooltip {
        max-width: none;
        white-space: nowrap;
    }
</style>
